import { apiClient } from '@empowernow/bff-auth-react';

function stripApi(path: string) { return path.replace(/^\/api/i, ''); }

export const api = {
  get: (path: string, opts?: any) => apiClient.get(stripApi(path), opts),
  post: (path: string, body?: any, opts?: any) => apiClient.post(stripApi(path), body, opts),
  put: (path: string, body?: any, opts?: any) => apiClient.put(stripApi(path), body, opts),
  patch: (path: string, body?: any, opts?: any) => apiClient.patch(stripApi(path), body, opts),
  delete: (path: string, opts?: any) => apiClient.delete(stripApi(path), opts)
};

export const idpApi = {
  getProfile: () => api.get('/idp/profile')
};

export const pdpApi = {
  listPolicies: () => api.get('/pdp/policies')
};

// Pages (designed in CRUDService)
export const pagesApi = {
  listPages: () => api.get('/crud/pages'),
  getPage: (id: string) => api.get(`/crud/pages/${id}`)
};

export const crudApi = {
  listEntities: (entity: string) => api.get(`/crud/${entity}`)
};

// Workflows (CRUDService workflow engine)
export const workflowApi = {
  // The designer uses /api/crud/workflows returning { items, total }
  listWorkflows: () => api.get('/crud/workflows'),
  getWorkflow: (id: string) => api.get(`/crud/workflows/${id}`),
  // Start by workflow name per canonical endpoint
  startByName: (workflowName: string, data?: any) =>
    api.post('/crud/workflow/start', { workflow_name: workflowName, data: data ?? {} }),
  // Convenience: execute by id (resolve name first)
  executeById: async (id: string, inputs?: any) => {
    const wfResp: any = await api.get(`/crud/workflows/${id}`);
    const name = (wfResp && typeof wfResp === 'object') ? (wfResp.data?.name ?? wfResp.name) : undefined;
    if (!name) throw new Error('Workflow name not found');
    return api.post('/crud/workflow/start', { workflow_name: name, data: inputs ?? {} });
  },
  getStatus: (executionId: string) => api.get(`/crud/workflow/status/${executionId}`),
  cancel: (executionId: string) => api.post(`/crud/workflow/cancel/${executionId}`),
  resume: (taskId: string, data?: any) => api.post(`/crud/workflow/resume/${taskId}`, data ?? {}),
  // Schema-first helpers (CRUDService commands)
  describeCommand: (system: string, objectType: string, action: string) =>
    api.get('/crud/commands/describe', { params: { system, object_type: objectType, action } }),
  formSchema: (system: string, objectType: string, action: string) =>
    api.get(`/crud/commands/form_schema?system=${encodeURIComponent(system)}&object_type=${encodeURIComponent(objectType)}&action=${encodeURIComponent(action)}`),
  normalizeParams: (system: string, objectType: string, action: string, params: any, schema?: any) =>
    api.post('/crud/commands/normalize', { system, object_type: objectType, action, params, schema }),
  // Catalog (systems/object_types/actions)
  browseCatalog: () => api.get('/crud/catalog/browse'),
  // Direct command start (no workflow authoring required)
  startCommand: (system: string, objectType: string, action: string, params: any) =>
    api.post('/crud/commands/start', { system, object_type: objectType, action, params }),
};

// Tasks API (ported from Visual Designer references)
export const tasksApi = {
  listTasks: (params?: any) => api.get('/crud/tasks', { params }),
  getTaskSummary: () => api.get('/crud/tasks/summary'),
  getTask: (id: string) => api.get(`/crud/tasks/${id}`),
  completeTask: (id: string, payload: any) => api.post(`/crud/tasks/${id}/complete`, payload),
};


